window.VH = window.VH === undefined ? {} : window.VH;
VH.QrCode = {
    btStart : false,
    html5QrCode : false,
    linkTemplate : false,
    replaceString : false,

    scanSuccess : function scanSuccess(decodedText, decodedResult) {
        let _t = VH.QrCode,
            guid = decodedText.split('/').last(),
            url = _t.linkTemplate.replace(_t.replaceString, guid)
        ;
        _t.html5QrCode.stop();
        _t.btStart.prop('disabled', false);
        document.location.href = url;
    },

    scanFail : function scanFail(errorMessage) {

    },

    scanError : function scanError(err) {

    },

    scan : function scan() {
        let _t = VH.QrCode;
        _t.html5QrCode
            .start(
                { facingMode: 'environment' },
                {
                    fps: 10//,    // Optional, frame per seconds for qr code scanning
                    //qrbox: 250  // Optional, if you want bounded box UI
                },
                _t.scanSuccess,
                _t.scanFail
            )
            .catch(_t.scanError);
        _t.btStart.prop('disabled', true);
    },

    initArrayHelper : function initArrayHelper() {
        if (!Array.prototype.last){
            Array.prototype.last = function(){
                return this[this.length - 1];
            };
        }
    },

    init : function init(startButtonId, readerId, linkTemplate, replaceString) {
        let _t = VH.QrCode;

        _t.initArrayHelper();

        _t.btStart = $('#' + startButtonId);
        _t.html5QrCode = new Html5Qrcode(readerId);
        _t.linkTemplate = linkTemplate;
        _t.replaceString = replaceString;

        _t.btStart.on('click', _t.scan);
    }
};
